<script setup lang="ts">
  import type { InfoSectionData } from '@/models/info';
  import type { PropType } from 'vue';

  defineProps({
    infoSectionData: {
      type: Object as PropType<InfoSectionData>,
      required: true
    }
  });
</script>

<template>
  <section>
    <div class="container">
      <div class="use-case-info-section">
        <div
          class="use-case-info-section__left"
          :style="{ '--bg-image': `url(${infoSectionData.infoSectionImage?.src})` }"></div>
        <div class="use-case-info-section__right">
          <h3 class="use-case-info-section__title">
            <div v-html="infoSectionData.infoSectionTitle"></div>
          </h3>
          <div class="use-case-info-section__content">
            <div v-html="infoSectionData.infoSectionContent"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
